export const ILFlagRound = ({width = '32px', height = '32px'}) => {
    return (
        <>
            <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 32c8.836 0 16-7.164 16-16S24.836 0 16 0 0 7.164 0 16s7.164 16 16 16Z" fill="#F0F0F0" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.96 3.477H6.049a15.99 15.99 0 0 0-3.691 4.177h27.295a16.013 16.013 0 0 0-3.69-4.177h-.003Zm-7.951 9.048h4.017L20.018 16l2.007 3.476h-4.016L16 22.96l-2.007-3.484H9.976L11.985 16l-2.011-3.475h4.018L16 9.041l2.009 3.484Zm-.775 5.61L18.468 16l-1.233-2.133h-2.468L13.533 16l1.234 2.133 2.467.001ZM16 11.724l.46.8h-.919l.46-.8Zm-2.782 2.142h-.919l.46.791.459-.79Zm-.918 4.267.459-.791.46.791h-.92Zm3.241 1.343.46.8.459-.8h-.919Zm4.16-1.343h-.919l.46-.791.458.791Zm0-4.267h-.92l.46.791.46-.79Zm6.25 14.658H6.04a16 16 0 0 1-3.691-4.178h27.294a16.003 16.003 0 0 1-3.692 4.178h-.002Z"
                    fill="#0052B4"
                />
            </svg>
        </>
    );
};
